// Internal modules
import { hasTreatment } from '@/lib/features/utils';
import { features, getExperiment } from '@/lib';

export const shouldRenderFields = (position?: string): boolean => {
  const shouldShowOptionalUpsellHalfSheet = features.hasFeature(
    'shouldShowOptionalUpsellHalfSheet',
  );
  const reorderExperiment =
    hasTreatment('FEATURE_ONBOARDING_OTP') ||
    shouldShowOptionalUpsellHalfSheet ||
    getExperiment('suppressSignup');

  const isTop = position === 'top';

  return reorderExperiment ? isTop : !isTop;
};
